import {Component, Input, OnInit} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {SfoUiJSONSchema7} from '../../../../metadata.model';
import { MatFormField, MatLabel, MatHint } from '@angular/material/select';
import { NgIf } from '@angular/common';
import { MatInput } from '@angular/material/input';

@Component({
    selector: 'sfo-integer-input',
    templateUrl: './integer-input.component.html',
    imports: [MatFormField, MatLabel, NgIf, MatInput, FormsModule, ReactiveFormsModule, MatHint]
})
export class IntegerInputComponent implements OnInit {
  @Input() schema!: SfoUiJSONSchema7;
  @Input() aFormControl!: FormControl;
  @Input() defaultValue: unknown;

  ngOnInit(): void {
    const currentValue = this.aFormControl.value;
    
    if (currentValue === null || currentValue === undefined) {
      const defaultValue = this.defaultValue ?? this.schema?.default;
      if (defaultValue !== undefined) {
        this.aFormControl.setValue(defaultValue, { emitEvent: false });
      }
    }
  }
}
